// extracted by mini-css-extract-plugin
export var header = "_h9-0";